// extracted by mini-css-extract-plugin
export default {"wrapper":"ParallaxAbout_wrapper__jKfA9","text":"ParallaxAbout_text__Eih0s"};